export default {
  "completePassword": {
    "button": {
      "submit": "Dërgoni"
    },
    "header": "Zgjidhni një fjalëkalim të ri",
    "placeholder": {
      "confirmPassword": "Konfirmoni fjalëkalimin",
      "password": "Fjalëkalimi"
    }
  },
  "dashboard": {
    "button": {
      "goToAllResults": "Të gjitha rezultatet",
      "myActions": "VEPRIMET E MIA",
      "ourCompanyResults": "REZULTATET TONA"
    },
    "card": {
      "body":
        "Këtu gjeni veprimet që keni zgjedhur të kryeni. Mund të shihni gjithashtu rezultatin tuaj dhe ta krahasoni me rezultatin e organizatës në tërësi.",
      "title": "Veprimet dhe rezultatet"
    },
    "greetings": {
      "day": "Përshëndetje, {username}!",
      "evening": "Mirëmbrëma, {username}!",
      "morning": "Mirëmëngjes, {username}!",
      "night": "Natën e mirë, {username}!",
      "simple": "Përshëndetje!"
    },
    "hello": "Përshëndetje {username}!",
    "integrations": {
      "title": "Integrimet"
    },
    "introHeadline": "{productTitle} në {organizationName}",
    "settings": {
      "ar": "Arabisht",
      "body": "Këtu mund të ndryshoni cilësimet e llogarisë suaj.",
      "da": "Danisht",
      "de": "Gjermanisht",
      "en": "Anglisht",
      "fr": "Frëngjisht",
      "logout": {
        "button": {
          "title": "Dilni"
        },
        "confirmation": {
          "areyousure":
            "Nëse dilni, duhet të kërkoni një kod të ri njëpërdorimësh për t'u identifikuar përsëri.",
          "cancel": "Anuloni",
          "false": "Anuloni",
          "no": "Anuloni",
          "title": "Dëshironi të dilni?",
          "true": "Dilni",
          "yes": "Dilni"
        },
        "loggedin": "Jeni identifikuar si {username}."
      },
      "no": "Norvegjisht",
      "sv": "Suedisht",
      "title": "Cilësimet"
    }
  },
  "error": {
    "CodeMismatchException":
      "Kodi njëpërdorimësh që futët është i pavlefshëm. Ju lutemi kontrollojeni dhe provoni përsëri.",
    "couldNotLoadResults":
      "Nuk mundëm t'i ngarkonim rezultatet. Ju lutemi, provoni përsëri.",
    "couldNotLoadSurveys":
      "Nuk mundëm t'i ngarkonim anketat. Ju lutemi, provoni përsëri.",
    "emailAtLeast3Letter":
      "Adresa e e-mailit duhet të përmbajë të paktën 3 shkronja",
    "emptyEmail": "Futni adresën tuaj të e-mailit",
    "emptyOrganization": "Futni emrin e organizatës suaj",
    "emptyPassword": "Futni një fjalëkalim",
    "EternalLoopError":
      "Llogaria juaj duket e pavlefshme. Ju lutemi kontaktoni mbështetjen e Puls.",
    "ExpiredCodeException":
      "Kodi njëpërdorimësh që futët ka skaduar dhe, për arsye sigurie, nuk mund të përdoret më.",
    "InvalidParameterException": "Mungon parametri i detyrueshëm Session.",
    "InvalidPasswordException":
      "Ju lutemi zgjidhni një fjalëkalim më të sigurt.",
    "LimitExceededException":
      "Shumë përpjekje të dështuara. Duhet të prisni pak përpara se të provoni përsëri.",
    "NotAuthorizedException":
      "Aktualisht nuk është e mundur të identifikoheni me llogarinë tuaj të përdoruesit.",
    "notMatchPassword": "Fjalëkalimet nuk përputhen!",
    "OrganizationNotFoundException":
      "Nuk gjetëm asnjë organizatë me atë emër, ju lutemi provoni përsëri.",
    "UserNotFoundException":
      "Nuk mundëm ta gjenim {username}. Provoni të klikoni përsëri lidhjen në e-mailin e ftesës!"
  },
  "forgotten": {
    "backToLogin": "Anuloni",
    "helptext":
      "Këtu mund të rivendosni fjalëkalimin tuaj. Do të merrni një e-mail në adresën e mësipërme me një kod, të cilin do ta futni në hapin tjetër.",
    "helptext-quickstart":
      "Sapo ju dërguam një kod të përkohshëm në adresën {email}. Futeni më poshtë dhe zgjidhni një fjalëkalim.",
    "helptext2": "Zgjidhni një fjalëkalim të sigurt.",
    "input": {
      "code": "Kodi që gjendet në e-mail",
      "organization": "Organizata",
      "password": "Fjalëkalimi i ri",
      "username": "Adresa e e-mailit"
    },
    "requestcode": {
      "submit": "Vazhdoni"
    },
    "setNewPassword": {
      "submit": "Filloni!"
    },
    "wait": "Ju lutemi prisni..."
  },
  "general": {
    "defaultProductTitle": "Puls⁺"
  },
  "help": {
    "card": {
      "body":
        "A ka diçka me të cilën mund t'ju ndihmojmë? Thjesht klikoni butonin më poshtë për të shkuar te qendra e ndihmës.",
      "title": "Ndihmë dhe mbështetje"
    },
    "description": "Mos u shqetësoni, ne jemi këtu për ju.",
    "title": "NDIHMË"
  },
  "ie": {
    "detailedText":
      "Platforma Puls mund të përdoret me Internet Explorer, por ai është një shfletues i vjetër që nuk i përmbush standardet moderne të uebit. Prandaj ju rekomandojmë të përdorni një nga shfletuesit më poshtë. Mund të përdorni gjithashtu telefonin tuaj celular.",
    "detailedTitle": "Rreth Internet Explorer",
    "readMore": "Lexoni më shumë",
    "warning":
      "Po përdorni Internet Explorer. Ju rekomandojmë të kaloni në një shfletues tjetër për përvojën më të mirë."
  },
  "integrations": {
    "addIntegrationSuccess": "Integrimi u shtua me sukses!",
    "allIntegrations": "Të gjitha integrimet",
    "apps": {
      "sftp": {
        "connectionInfo": "Do të ngarkohet në {dir} në serverin SFTP.",
        "connectionTitle": "Lidhja SFTP",
        "title": "SFTP"
      },
      "slack": {
        "connectionInfo": "Lidhur me ekipin {teamName} dhe kanalin {channel}",
        "connectionTitle": "Slack te {appDetail}",
        "title": "Slack"
      }
    },
    "back": "Kthehuni",
    "buttons": {
      "deleteIntegration": {
        "help": "Kjo do ta heqë {type} nga Puls."
      }
    },
    "connectedSince": "Lidhur që nga {date}",
    "empty": {
      "description":
        "Duke shtuar një integrim, mund ta lidhni Puls me shërbimin tuaj. Klikoni butonin më poshtë për t'u lidhur me një shërbim."
    },
    "errors": {
      "invalidIncomingIntegration":
        "Të dhëna hyrëse të pavlefshme për integrimin! Nuk mund të vazhdohet."
    },
    "events": {
      "surveyCompleted": {
        "description":
          "Kur përfundon një anketë, rezultatet për {groupTitle} dërgohen automatikisht përmes integrimit.",
        "title": "Anketa përfundoi"
      },
      "title": "Zgjidhni ngjarjen që do të aktivizojë integrimin"
    },
    "groups": {
      "title": "Zgjidhni grupin që dëshironi ta lidhni me {appName}"
    },
    "integrationTo": "Integrim me {appName}",
    "nothingSelected": "Zgjidhni...",
    "setupIntegration": {
      "saveButtonTitle": "Ruani",
      "title": "Konfiguroni integrimin me {appName}"
    },
    "title": "Integrimet"
  },
  "loggedOut": {
    "loginButton": {
      "title": "Identifikohuni përsëri"
    },
    "title": "Tani keni dalë!"
  },
  "login": {
    "button": {
      "forgotPassword": "Keni harruar fjalëkalimin?",
      "submit": "Identifikohuni"
    },
    "captchaLegal": {
      "disclaimer":
        "Kjo faqe mbrohet nga reCAPTCHA dhe zbatohen {toc} dhe {privacyPolicy} të Google.",
      "policy": "Politika e privatësisë",
      "toc": "Kushtet e shërbimit"
    },
    "header": "Identifikimi",
    "placeholder": {
      "email": "Adresa e e-mailit",
      "organization": "Organizata",
      "password": "Fjalëkalimi"
    }
  },
  "navbar": {
    "welcome": "Mirë se vini"
  },
  "notFound": {
    "alert": "Kjo faqe nuk ekziston. Ju lutemi, kthehuni te faqja e mëparshme.",
    "backButton": "Përmbledhje",
    "title": "Nuk u gjet"
  },
  "results": {
    "participants": "{participants} pjesëmarrës",
    "publicSurvey": "Anketë publike",
    "surveys": {
      "completed": {
        "latest": "Anketa e fundit e përfunduar",
        "title": "Rezultatet për anketat e përfunduara"
      },
      "emptyResult": "Së shpejti do të mund të shihni rezultatet këtu!",
      "published": {
        "title": "Shikoni rezultatet"
      }
    }
  },
  "setup": {
    "attributes": {
      "birthdate": {
        "info":
          "Data e lindjes nevojitet për të përgatitur statistika sipas grupmoshave.",
        "label": "Data e lindjes"
      },
      "birth_date": {
        "info":
          "Data e lindjes nevojitet për të përgatitur statistika sipas grupmoshave.",
        "label": "Data e lindjes"
      },
      "custom:employed_since": {
        "info":
          "Kjo është data kur jeni punësuar. Nuk është e nevojshme të jetë e saktë. Nëse nuk jeni të punësuar, lëreni fushën bosh.",
        "label": "Data e punësimit"
      },
      "employment_date": {
        "info":
          "Kjo është data kur jeni punësuar. Nuk është e nevojshme të jetë e saktë. Nëse nuk jeni të punësuar, lëreni fushën bosh.",
        "label": "Data e punësimit"
      },
      "family_name": {
        "label": "Mbiemri"
      },
      "gender": {
        "other": "Tjetër",
        "female": "Grua",
        "info":
          "Ju pyesim për gjininë në mënyrë që kjo e dhënë të përfshihet në statistika. Nëse nuk dëshironi, mund të mos zgjidhni asgjë.",
        "label": "Zgjidhni gjininë:",
        "male": "Burrë",
        "wontsay": "Preferoj të mos e tregoj"
      },
      "given_name": {
        "label": "Emri"
      },
      "locale": {
        "ar": "Arabisht",
        "da": "Danisht",
        "de": "Gjermanisht",
        "dk": "Danisht",
        "en": "Anglisht",
        "es": "Spanjisht",
        "et": "Estonisht",
        "fi": "Finlandisht",
        "fr": "Frëngjisht",
        "hr": "Kroatisht",
        "info":
          "Zgjidhni gjuhën që preferoni të përdorni. Kjo mund të ndryshohet edhe më vonë.",
        "it": "Italisht",
        "label": "Zgjidhni gjuhën:",
        "ms": "Malajisht",
        "nl": "Holandisht",
        "no": "Norvegjisht",
        "pl": "Polonisht",
        "ru": "Rusisht",
        "sl": "Sllovenisht",
        "so": "Somalisht",
        "sq": "Shqip",
        "sr": "Serbisht",
        "sv": "Suedisht",
        "uk": "Ukrainisht"
      }
    },
    "button": {
      "submit": "Ruani",
      "tryAgain": "Provoni përsëri"
    },
    "error": {
      "badPassword": "Ju lutemi zgjidhni një fjalëkalim më të sigurt.",
      "clickLinkAgain":
        "Ju lutemi klikoni edhe një herë lidhjen në e-mailin e mirëseardhjes. Nëse problemi vazhdon, ju lutemi kontaktoni support@puls-solutions.com",
      "invalid": "Kjo lidhje nuk është më e vlefshme.",
      "noPassword": "Duhet të zgjidhni një fjalëkalim.",
      "passwordsMustMatch": "Fjalëkalimet duhet të përputhen.",
      "sessionError": "Hasëm një problem!",
      "SSONotFound": "Nuk ka konfigurim SSO për organizatën.",
      "unexpected": "Ndodhi një problem i papritur"
    },
    "header": "Filloni me Puls!",
    "introText":
      "Përshëndetje{name}! Jeni ftuar të përdorni Puls, një platformë për angazhimin e punonjësve. Aktivizoni llogarinë tuaj duke plotësuar formularin më poshtë. ",
    "introTextVolontary":
      "Vetëm fusha e fjalëkalimit është e detyrueshme.",
    "login": "Vazhdoni",
    "placeholder": {
      "confirmPassword": "Konfirmoni fjalëkalimin",
      "newPassword": "Zgjidhni një fjalëkalim"
    }
  },
  "sso": {
    "button": {
      "continue": "Vazhdoni",
      "login": "Identifikimi SSO",
      "signout": "Dilni"
    },
    "error": {
      "generic": "Ndodhi një problem gjatë identifikimit: {error}"
    },
    "noUserAccountFound": "Nuk u gjet asnjë llogari përdoruesi në organizatë"
  },
  "start": {
    "button": {
      "getOrganizationData": {
        "title": "Vazhdoni"
      },
      "requestCode": {
        "title": "Merrni kodin njëpërdorimësh"
      },
      "submitCode": {
        "title": "Identifikohuni"
      }
    },
    "confirmRequestCode": {
      "header": {
        "description":
          "Fillimisht duam të sigurohemi që jeni personi i duhur! Kur të vazhdoni, do të dërgohet një kod njëpërdorimësh. Përdoreni në hapin tjetër për t'u identifikuar në {productTitle} në {organizationName}.",
        "help":
          "Keni kërkuar së fundmi një kod. Sigurohuni që ta futni kodin në dritaren ku e kërkuat. Nëse vazhdoni këtu, do të dërgohet një kod i ri."
      }
    },
    "enterCode": {
      "form": {
        "code": {
          "placeholder": "kodi njëpërdorimësh"
        }
      },
      "header": {
        "deliveryMedium": {
          "EMAIL": "e-mail",
          "SMS": "SMS"
        },
        "description":
          "Ju është dërguar një kod njëpërdorimësh përmes {deliveryMedium}. Lëreni këtë dritare të hapur dhe kthehuni këtu për të futur kodin më poshtë:",
        "title": "Mirë se vini në {productTitle}!"
      },
      "help": {
        "noCodeDescriptionEmail":
          "Kodi u dërgua në adresën tuaj të e-mailit që përmban '{destination}'. Dërguesi është \"Puls\". Mund të duhen një ose dy minuta derisa kodi të mbërrijë. Nëse nuk e gjeni, kontrolloni dosjen e postës së padëshiruar (spam). Mbajeni këtë dritare të hapur dhe futeni kodin më sipër.",
        "noCodeDescriptionSMS":
          "Kodi u dërgua me SMS në numrin tuaj të telefonit që përmban '{destination}'. Mund të duhen një ose dy minuta derisa të mbërrijë. Nëse nuk e njihni numrin e telefonit, ju lutemi kontaktoni administratorin tuaj.",
        "noCodeLinkTitle": "Nuk e morët kodin?",
        "noCodeStartOverLinkTitle": "Filloni nga e para"
      }
    },
    "enterEmail": {
      "form": {
        "username": {
          "placeholder": "adresa e e-mailit"
        }
      },
      "header": {
        "description": "Futni adresën tuaj të e-mailit në {organizationName}:"
      }
    },
    "enterOrganization": {
      "form": {
        "organization": {
          "placeholder": "emri i organizatës"
        }
      },
      "header": {
        "description": "Filloni duke futur emrin e organizatës ku bëni pjesë.",
        "invalid": {
          "spaces": "Mos përdorni hapësira.",
          "specialchars": "Përdorni vetëm shkronja.",
          "uppercase": "Përdorni vetëm shkronja të vogla."
        }
      }
    }
  },
  "surveys": {
    "description": "Këto anketa janë aktualisht në vazhdim:",
    "descriptionOneSurveyOnly": "Zgjidhni anketën më poshtë për të filluar!",
    "descriptionOneSurveyOnlyUserDone":
      "Anketa është ende në vazhdim. Zgjidheni për të parë veprimet që keni zgjedhur.",
    "ended": "përfundoi",
    "youreDone": "E keni përfunduar"
  },
  "surveysToFillIn": {
    "description": "Këto anketa janë aktualisht në vazhdim:",
    "descriptionOneSurveyOnly": "Zgjidhni anketën më poshtë për të filluar!",
    "descriptionOneSurveyOnlyUserDone":
      "Anketa është ende në vazhdim. Zgjidheni për të parë veprimet që keni zgjedhur.",
    "emptyResult":
      "Për momentin nuk keni asnjë anketë për të plotësuar. Më poshtë mund të shihni veprimet, komentet ose rezultatet tuaja.",
    "ended": "përfundoi",
    "endsIn": "përfundon",
    "retry": "Provoni përsëri",
    "title":
      "Anketa aktuale|Keni një anketë për të plotësuar|Keni {count} anketa për të plotësuar",
    "youreDone": "E keni përfunduar"
  },
  "user": {
    "attributes": {
      "birthdate": {
        "info":
          "Data e lindjes nevojitet për të përgatitur statistika sipas grupmoshave.",
        "label": "Data e lindjes"
      },
      "birth_date": {
        "info":
          "Data e lindjes nevojitet për të përgatitur statistika sipas grupmoshave.",
        "label": "Data e lindjes"
      },
      "custom:employed_since": {
        "info":
          "Kjo është data kur jeni punësuar. Nuk është e nevojshme të jetë e saktë. Nëse nuk jeni të punësuar, lëreni fushën bosh.",
        "label": "Data e punësimit"
      },
      "employment_date": {
        "info":
          "Kjo është data kur jeni punësuar. Nuk është e nevojshme të jetë e saktë. Nëse nuk jeni të punësuar, lëreni fushën bosh.",
        "label": "Data e punësimit"
      },
      "family_name": {
        "label": "Mbiemri"
      },
      "gender": {
        "other": "Tjetër",
        "female": "Grua",
        "info":
          "Ju pyesim për gjininë në mënyrë që kjo e dhënë të përfshihet në statistika. Nëse nuk dëshironi, mund të mos zgjidhni asgjë.",
        "label": "Zgjidhni gjininë:",
        "male": "Burrë",
        "wontsay": "Preferoj të mos e tregoj"
      },
      "given_name": {
        "label": "Emri"
      },
      "locale": {
        "ar": "Arabisht",
        "da": "Danisht",
        "de": "Gjermanisht",
        "en": "Anglisht",
        "es": "Spanjisht",
        "et": "Estonisht",
        "fi": "Finlandisht",
        "fr": "Frëngjisht",
        "hr": "Kroatisht",
        "info": "Zgjidhni gjuhën që preferoni të përdorni.",
        "it": "Italisht",
        "label": "Zgjidhni gjuhën:",
        "ms": "Malajisht",
        "nl": "Holandisht",
        "no": "Norvegjisht",
        "pl": "Polonisht",
        "ru": "Rusisht",
        "sl": "Sllovenisht",
        "so": "Somalisht",
        "sq": "Shqip",
        "sr": "Serbisht",
        "sv": "Suedisht",
        "uk": "Ukrainisht",
        "zh": "Kinezisht"
      }
    },
    "button": {
      "cancel": "Anuloni",
      "skip": "Kthehuni",
      "submit": "Ruani",
      "tryAgain": "Provoni përsëri"
    },
    "error": {
      "badPassword": "Ju lutemi zgjidhni një fjalëkalim më të sigurt.",
      "clickLinkAgain":
        "Ju lutemi klikoni edhe një herë lidhjen në e-mailin e mirëseardhjes. Nëse problemi vazhdon, ju lutemi kontaktoni support@puls-solutions.com",
      "invalid":
        "Kjo lidhje nuk është më e vlefshme, klikoni më poshtë në vend të saj:",
      "noPassword": "Duhet të zgjidhni një fjalëkalim.",
      "passwordsMustMatch": "Fjalëkalimet duhet të përputhen.",
      "sessionError": "Hasëm një problem!",
      "SSONotFound": "Nuk ka konfigurim SSO për organizatën.",
      "unexpected": "Ndodhi një problem i papritur"
    },
    "header": "Cilësimet e përdoruesit",
    "introText": "Kontrolloni që profili juaj i përdoruesit të jetë i saktë.",
    "introTextNoAttributes":
      "Aktualisht nuk ka cilësime për të ndryshuar këtu.",
    "introTextVolontary":
      "Plotësimi i informacionit më poshtë është vullnetar.",
    "login": "Vazhdoni"
  },
  "whistleblower": {
    "buttons": {
      "cancel": "Anuloni",
      "done": "Në rregull",
      "send": "Dërgoni në mënyrë anonime"
    },
    "description":
      "Ju ofrojmë mundësinë të dërgoni në mënyrë anonime një raport për sjellje të paligjshme ose shkelje që keni vërejtur në {organizationName}.",
    "detailedDescription":
      "Ja si funksionon. Shkruani raportin tuaj në kutinë e tekstit më poshtë. Kur e dërgoni raportin, një e-mail i dërgohet një marrësi të paracaktuar në organizatën tuaj, i cili ka përgjegjësinë të marrë masa. Marrësi nuk mund ta shohë në asnjë mënyrë që mesazhi është dërguar nga ju, vetëm që ka ardhur nga platforma Puls. Nëse dëshironi të kontaktoheni, sigurohuni që ta përfshini këtë informacion në mesazhin tuaj. Nëse dëshironi të mbeteni anonim, mund të përdorni një adresë e-maili të përkohshme ose një kartë SIM të përkohshme për telefonin celular.",
    "doneText":
      "Faleminderit që dërguat raportin tuaj. Do ta trajtojmë me seriozitet. Nëse keni dhënë të dhënat e kontaktit, do t'ju përgjigjemi sa më shpejt të jetë e mundur!",
    "linkTitle": "Lexoni më shumë këtu",
    "linkToHelp": "https://www.puls-solutions.com/help/TODO",
    "notEnabled": {
      "description":
        "Na vjen keq. Funksioni i sinjalizimit nuk është aktivizuar nga organizata juaj.",
      "title": "Nuk është i disponueshëm"
    },
    "placeholder":
      "Shkruani raportin tuaj këtu. Jini sa më konkretë që të jetë e mundur dhe na tregoni nëse dhe si dëshironi të kontaktoheni.",
    "title": "Dërgoni një raport anonim"
  }
}
